<div class="d-flex justify-content-center">
  <div class="rounded-circle p-4 mb-3 bg-light d-flex align-items-center">
    <i class="{{iconClass}} fa-5x text-info"></i>
  </div>
</div>
<h2 class="h4">{{title}}</h2>
<p class="text-muted">{{message}}</p>
